module.exports = "<div class=\"tabs-header row\"> <div class=\"tab-header\" *ngFor=\"let tab of tabs\" [ngClass]=\"{'active': tab.active}\" (click)=\"selectTab(tab)\"> {{tab.title}} </div> </div> <div class=\"tabs-content row\"> <ng-content></ng-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/tabs/tabs.component.html
// module id = 202
// module chunks = 0